module.exports = __webpack_public_path__ + "static/media/item_sli_suggest_des.19851bfc.png";